import React from 'react'
import Table from 'UI/Table';
import PoliciesTable from './PoliciesTable';

const LocationsTable = ({ locations }) => (
  <Table
    data={locations}
    columns={[
      { Header: 'Location', accessor: 'name' },
      { Header: 'Data Written', accessor: 'data_written_in_bytes', Cell: row => row.original.data_written },
      { Header: 'Non-Aged Data Written', accessor: 'non_aged_data_written_in_bytes', Cell: row => row.original.non_aged_data_written },
      { Header: 'Job Count', accessor: 'job_count', Cell: ({ value }) => parseInt(value).toLocaleString() }
    ]}
    pageSize={locations.length}
    showPagination={false}
    SubComponent={({ original: { storage_policies } }) => <PoliciesTable {...{ storage_policies }} />}
  />
)

export default LocationsTable
